import { useState, useEffect } from "react"

import useFetch from "shared/model/useFetch"
import useAlertModalAtom from "shared/model/useAlertModalAtom"

const usePostUtilSms = (countryCodeRef, contactRef) => {

    const [fetchResult, fetchRequest] = useFetch()
    const [, setAlert] = useAlertModalAtom()
    const [isSent, setIsSent] = useState(false)

    const clickEvent = () => {
        fetchRequest("POST", "/util/sms", {
            "international_number": countryCodeRef?.current,
            "contact": contactRef?.current?.value
        })
    }

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 200:
                setIsSent(true)
                break
            case 400:
                if (fetchResult?.data?.error_code === "international_number") setAlert("국제번호 입력 양식을 확인해 주세요.")
                else if (fetchResult?.data?.error_code === "contact") setAlert("연락처 입력 양식을 확인해 주세요.")
                else setAlert("입력한 값의 형식이 잘못되었습니다.")
                break
        }
    }, [fetchResult])

    return [isSent, clickEvent]
}

export default usePostUtilSms